import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';
import { updateEmail, updatePassword } from '@angular/fire/auth';
import { Auth } from '@angular/fire/auth';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule], // ensure these if using standalone
})
export class ProfileComponent implements OnInit {
  profileForm!: FormGroup;
  isLoading = false;
  showSuccess = false;
  isEditMode = false;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private auth: Auth
  ) {}

  ngOnInit(): void {
    this.profileForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      lastName: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.minLength(6)]],  // optional field
      confirmPassword: ['']
    }, {
      validators: this.passwordsMatchValidator
    });

    this.loadUserData();
  }
  passwordsMatchValidator(group: FormGroup) {
    const password = group.get('password')?.value;
    const confirm = group.get('confirmPassword')?.value;
    return password && confirm && password !== confirm ? { passwordMismatch: true } : null;
  }
  toggleEditMode() {
    this.isEditMode = !this.isEditMode;
    Object.keys(this.profileForm.controls).forEach(key => {
      const control = this.profileForm.get(key);
      if (this.isEditMode) {
        control?.enable();
      } else {
        control?.disable();
      }
    });
  }
  async loadUserData() {
    this.isLoading = true;
    const user = this.authService.currentUser;

    if (user) {
      this.profileForm.patchValue({
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        email: user.email || '',
      });
    }

    this.isLoading = false;
  }

  async onSubmit() {
    if (this.profileForm.invalid) {
      this.profileForm.markAllAsTouched();
      return;
    }
  
    this.isLoading = true;
  
    try {
      const { firstName, lastName, email, password } = this.profileForm.value;
      const currentUser = this.auth.currentUser;
  
      if (currentUser) {
        // Update email if changed
        if (email !== currentUser.email) {
          await updateEmail(currentUser, email);
        }
  
        // Update password if entered
        if (password) {
          await updatePassword(currentUser, password);
        }
  
        // Update Firestore user data
        await this.authService.updateUserData(currentUser.uid, {
          firstName,
          lastName,
          email,
        });
  
        await this.authService.refreshCurrentUser();
        this.showSuccess = true;
        setTimeout(() => (this.showSuccess = false), 3000);
      }
    } catch (error: any) {
      console.error(error);
      alert(error?.message || 'An error occurred while updating your profile.');
    }
  
    this.isLoading = false;
  }

  get f() {
    return this.profileForm.controls;
  }
}
